import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isTVDevice } from '../../utils/tvDetect';

export function FocusRestorer() {
  const location = useLocation();

  useEffect(() => {
    if (isTVDevice()) {
      import('@noriginmedia/norigin-spatial-navigation').then(({ setFocus }) => {
        setTimeout(() => setFocus('PAGE_DEFAULT'), 100);
      });
    }
  }, [location.pathname]);

  return null;
}
